module.exports = __webpack_public_path__ + "img/livingP.b4ee92c8.svg";